import { IAsyncFlowInitialState } from 'store/types';

export const asyncFlowInitialState: IAsyncFlowInitialState = {
  loading: false,
  data: null,
  error: null,
};
